import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    if (!sessionId) {
      navigate("/admin", { replace: true });
      return;
    }

    api
      .post("/auth/session", { session_id: sessionId }, { headers: { "X-Session-ID": sessionId } })
      .then((res) => {
        setUser(res.data);
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { replace: true, state: { user: res.data } });
      })
      .catch(() => {
        navigate("/admin", { replace: true });
      });
  }, []); // eslint-disable-line

  return (
    <div className="flex min-h-screen items-center justify-center bg-ink">
      <div className="text-center">
        <div className="mx-auto mb-4 h-10 w-10 animate-spin rounded-full border-2 border-gold border-t-transparent" />
        <p className="text-sm uppercase tracking-widest text-white/50">Signing you in…</p>
      </div>
    </div>
  );
}
